import { render, staticRenderFns } from "./EmailReceivedSettings.vue?vue&type=template&id=9e06950c&scoped=true"
import script from "./EmailReceivedSettings.vue?vue&type=script&lang=js"
export * from "./EmailReceivedSettings.vue?vue&type=script&lang=js"
import style0 from "./EmailReceivedSettings.vue?vue&type=style&index=0&id=9e06950c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e06950c",
  null
  
)

export default component.exports